import ApiUrls from "../helper/api-urls";
import ApiHelper from "../helper/api-helper";


// const getTelehealthToken = (eventId,userName, isHost) => {
//     return ApiHelper.getRequest(ApiUrls.GET_TELEHEALTH_TOKEN + 'eventId' + "=" + eventId + "&" + "userName" + "=" + userName + "&" + "isHost" + "=" + isHost );

//   };


const getTelehealthToken = (eventId, userName, userId, isHost, isClient) => {
  var data = {
    "eventId": eventId,
    "userName": userName,
    "userId": userId,
    // "isHost": isHost,
    "isClient": isClient
  }

  return ApiHelper.telehealthPostRequest(ApiUrls.GET_TELEHEALTH_TOKEN, data,);
};

const getClientTelehealthToken = (userId, isClient, roomId, userName) => {
  var data = {
    "userId": userId,
    "isClient": isClient,
    "roomId": roomId,
    "userName": userName
  }
  return ApiHelper.telehealthPostRequest(ApiUrls.GET_TELEHEALTH_ACCESS_TOKEN, data);
};


const closeTelehealthSession = (roomId) => {
  return ApiHelper.getRequest(ApiUrls.CLOSE_TELEHEALTH_SESSION + roomId);

};

const sendLinkService = (roomName, clientDetails) => {
  const data = {
    clientId: clientDetails?.id,
    roomId: roomName
  }
  return ApiHelper.postRequest(ApiUrls.SEND_TELEHEALTH_LINK_TO_CLIENT, data);

};



export const VideoService = {
  getTelehealthToken,
  closeTelehealthSession,
  getClientTelehealthToken,
  sendLinkService
};